/** Keyframes for the "working" shimmer, injected once by ChatPage. */
export const shimmerStyle = `
  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`;
